<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p>The day that the bombs dropped was a day just like any other. People were going about their normal business with no idea what was about to befall them.</p>
<p>On an island far, far south of Fort Calder, there was a man, a man with a plan, a man with a deadly plan.</p>
<p>He had worked for five years creating the deadly bomb that would desecrate wherever it touched. The bombs were small, only about three cm long, the first one cm was filled with a deadly chemical and the following two cm was a very powerful explosive.</p>
<p>Once he had perfected his bomb, he then had his employees make thousands upon thousands of them; then he sold them all over the world.</p>
<p>When the bombs were fired, the powerful explosive destroyed all of the buildings that it came into contact with and the chemical caused all warm-blooded people and animals to disintegrate and totally disappear.</p>
<p>However, not everyone was killed, a few survived. Some who were underground or protected by metal or water survived.</p>
<p>Beautiful, telepathic, identical twin girls, find themselves leading a group of teenagers, children and dogs to safety at their family farm, just outside of Fort Calder.</p>
<p>The twins, Ali and Anna, who are affectionately both known as Alinna, Ryan and his sister Morgan, George, Chip who has two dogs Arnie and Honey, Daniel who has a broken leg, Rosie and her younger brother and sister Freddie and Bonnie, all make it to the farmhouse.</p>
<p>Soon they are joined by Andrew, his wife Mel and five-year-old Joshie, who they had found alone in the rubble.</p>
<p>Armed with crossbows, the notorious gang, ‘The Skulls,’ soon find their way to the farm. Where they attack the group.</p>
<p>Two Skulls and Morgan end up dead and Daniel gets his almost healed leg broken for a second time.</p>
<p>Blinded by grief over Morgan, Ryan leaves the farm to go it alone. Followed a short time later by Andrew and Mel, who leave Joshie behind at the farm house with Rosie and the other children.</p>
<p>Meanwhile, three girls and a boy, Jaq, April, Elli and Robbie, make their camp and get their provisions from the ruined houses at the top of Fort Calder.</p>
<p>Also, three boys, Mark, Ben and Jake make camp and get their provisions from the ruined houses at the bottom of the town.</p>
<p>Mrs Burniston, is also at the bottom of the town in her neighbour’s house. She is a very difficult, unpleasant woman who has rejected the twins offer of help.</p>
<p>Angel and a neighbour’s five-year-old daughter Madi, make their camp in the garden centre on the edge of town.</p>
<p>When Angel and Madi leave the garden centre, the two remaining Skulls and their two very frightened girlfriends move in. The girls, Carole-Anne and Naomi have tried and failed to escape from the Skulls.</p>
<p>Unbeknown to everyone, the man with the plan, Roeber Baptiste, the instigator of the war and the maker of the chemical that has killed nearly everyone, is searching for survivors, particularly, young teenage survivors.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?71f65e7a